import { Box, Divider, Grid, Paper, Stack } from '@mui/material'
import React from 'react'
import { addActiveClass, customStyles, justifyCenter, spaceBetween } from '../../../styles'
import { CaptionText } from '../text/CaptionText'
import { SmallText } from '../text/SmallText'
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import styled from '@emotion/styled'
import { useNavigate, useParams } from 'react-router-dom'
import EditIcon from '@mui/icons-material/Edit';
import { editAccount, removeAccount } from '../../../slices/accountsSlice'
import { getProducts } from '../../../actions'
import { useLocalStorage } from '../../../hooks/useLocalStorage'
import { MainButton } from '../buttons/MainButton'
import { setProductId } from '../../../slices/productSlice'
import { addOrderId, setAccount } from '../../../slices/orderSlice'
import { useDispatch } from 'react-redux'
import { deleteAccount } from '../../../actions/accountsAction'
import CloseIcon from '@mui/icons-material/Close';

export const RegularTab = ({ all, icon, title, content, legal=false, route, id, serviceType, postalCode, data }) => {
  const Icon =styled(icon)(() => ({
    color: customStyles.colors.main,
    fontSize: customStyles.fontSize.large
   //  marginRight: 10
  }))
  const navigate = useNavigate()
  const [ userAuthorization ] = useLocalStorage('login-token', null)
  const dispatch = useDispatch()  
//   const { id:idParams } = useParams()
  const handleNavigate = () => {
   if(!legal){
      dispatch(setAccount(data))
    dispatch(getProducts(id, userAuthorization?.token))
    serviceType === 'PORTATIL' ? navigate(`/dashboard/${data?.id}/portatil`) : navigate(`/dashboard/${data?.id}/estacionario`)
   } else {
      navigate('/wop')
   }
  }
  const handleEditAccount = () => {
   dispatch(editAccount({id, editMode: true}))
   navigate(`/dashboard/${id}/editar-direccion`)
  }

  const handleDelete= () => {
   dispatch(deleteAccount(id, userAuthorization?.token))
   all ? dispatch(removeAccount({id, all:true})) :dispatch(removeAccount(id))
  }

  return (
   //  <Paper  sx={{ marginBottom: 2,  ...justifyCenter, flexDirection: 'column', height: 150}} >
   //   <Grid container spacing={1} alignItems="center" p={1} >
   //       <Grid item xs={ legal ? 9 : 3} sx={{ ...justifyCenter }}>
   //          { icon && <Icon/> }
   //          {/* <SmallText text={ title }/> */}
   //       </Grid>
   //       {
   //          !legal &&
   //          <Grid item container xs={7}>
   //             <CaptionText text={content}/>
   //          </Grid>
   //       }
   //       <Grid item xs={ 2 } sx={ {...spaceBetween, color: customStyles.colors.main} }>
   //          <EditIcon sx={{fontSize: customStyles.fontSize.small}} onClick={ handleEditAccount}/>
   //          <ChevronRightIcon onClick={handleNavigate}/>
   //       </Grid>
   //    </Grid>
   // </Paper>
   //x={{ overFlow: 'hidden', borderTopLeftRadius: 5,borderTopRightRadius: 5 , cursor: 'pointer', ...addActiveClass }}
   <Grid item xs={12} sm={6} md={4} sx={{ textAlign: 'center',  position: 'relative'}} >
      <Paper sx={ {...justifyCenter, flexDirection: 'column', height: 200, position: 'relative', padding: '30px 10px',} }>
      { icon && <Icon /> }
      <SmallText text={title}/>
      <CaptionText text={content}/>
      {
         !legal &&
         <>
         <Stack direction="row" spacing={1}>
      {/* <Box sx={{ alignSelf: 'end', marginTop: 2, ...spaceBetween, color: customStyles.colors.secondary}}> */}
         {/* <MainButton sx={ justifyCenter } icon={<EditIcon sx={{fontSize: customStyles.fontSize.medium, }} onClick={ handleEditAccount}/>} size={customStyles.buttonSize.small} variant="outlinead"/>
         <ChevronRightIcon sx={{fontSize: customStyles.fontSize.xl, }} onClick={handleNavigate}/> */}
            <MainButton text="Editar" variant="outlined" size={customStyles.buttonSize.small} onClick={handleEditAccount}/>
            <MainButton text="Ir" variant="contained" size={customStyles.buttonSize.small} onClick={handleNavigate}/>
         </Stack>
         <CloseIcon  onClick={handleDelete} sx={{ position: 'absolute', top: 3, right: 3, cursor: 'pointer', ...addActiveClass }}/>
         </>
      }
      { legal && <MainButton text="Ir" variant="contained" size={customStyles.buttonSize.small} onClick={handleNavigate}/> }
      </Paper>
   </Grid>
  )
}
